import styled from 'styled-components';

const MainContainer = styled.div`
  width: 100%;
  .calendarMargin {
    margin-right: 5.33px;
    width: 16px;
    height: 16px;
  }

  .font11 {
    font-size: 11px;
  }

  .liBorder {
    border: 1px solid #161d1f;
    border-radius: 4px;
    padding: 1px 8px 1px;
    margin-right: 4px;
  }

  .defaultState {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    display: grid;
    width: 100%;
  }

  .gridCard {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 16px;
    display: grid;
    width: 100%;
    margin-bottom: 32px;
  }

  .eventoCancelado {
    pointer-events: none;
    span,
    p {
      color: #8090bb;
    }
    div {
      color: #8090bb;
    }

    img {
      filter: brightness(1);
      filter: saturate(0);
    }
  }

  .tabletsTitle {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    color: #161d1f;
    padding-bottom: 12px;
  }

  .tabletsSubtitle {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #161d1f;
    padding-top: 12px;
    margin-bottom: 8px;
  }

  .reservationCards {
    display: grid;
    gap: 8px;
    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
    @media (min-width: 1280px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .containerElements {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .containerResourceCard {
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 24px;
  }
  .containerResourceCard::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    .gridCard {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (min-width: 992px) {
    padding-right: 18px;
  }

  @media (min-width: 1280px) {
    display: flex;
    align-items: center;
    flex-direction: column;
    .fixedWidth {
      width: 1128px;
    }
    .gridCard {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 24px;
    }
  }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #161d1f;
  padding-bottom: 16px;
  @media (min-width: 768px) {
    padding-bottom: 24px;
  }

  @media (min-width: 992px) {
    align-self: center;
  }
`;

const ContainerDefaultMessage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0px;
  gap: 16px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const DefaultText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: start;
  color: #161d1f;
`;

const SubTitleSection = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  color: #161d1f;

  @media (min-width: 360px) {
    margin-top: 16px;
  }

  @media (min-width: 768px) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;
const FixedWithContainer = styled.div.attrs({
  className: 'fixedWidth'
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 100px;

  .reserve__container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .title__reserve {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #161d1f;

    @media (min-width: 992px) {
      align-self: left;
    }
  }

  .payments {
    margin: 0 auto;
    width: 100%;
    color: var(--text-text02);
  }

  .card__services {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 640px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: 992px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 24px;

      .title__reserve {
        self-align: center;
      }
    }
  }

  .card__payments {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 640px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: 992px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;

      .title__reserve {
        self-align: center;
      }
    }
  }

  .four__cards__courses {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 640px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: 992px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      gap: 24px;

      .title__reserve {
        self-align: center;
      }
    }
  }

  .card {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 1.2px 4px #eaeef1;
    border-radius: 4px;
    background: #ffffff;
    padding: 12px;
    gap: 4px;

    .card__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0px;
      gap: 10px;

      p {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #161d1f;
        text-align: initial;
      }
    }

    .card__detail {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4f6168;
      text-align: start;
    }

    &:hover {
      background: #e2dffd;
    }

    &:focus {
      background: #c6c0fc;
    }

    &:active {
      background: #c6c0fc;
    }
  }
`;

export {
  MainContainer,
  Title,
  ContainerDefaultMessage,
  DefaultText,
  FixedWithContainer,
  SubTitleSection
};
